import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsertRowRightOutlinedSvg from "@ant-design/icons-svg/es/asn/InsertRowRightOutlined";
import AntdIcon from '../components/AntdIcon';
var InsertRowRightOutlined = function InsertRowRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: InsertRowRightOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(InsertRowRightOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'InsertRowRightOutlined';
}
export default RefIcon;